import React from 'react';
import { Modal, Fade, Backdrop, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import ButtonBase from '../Buttons/ButtonBase';

const useStyles = makeStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: isMobile ? 15 : 0,
    },
    paper: {
      display: 'flex',
      flexDirection: 'Column',
      width: isMobile ? 360 : 464,
      margin: isMobile ? '50px 0 0 0' : 0,
      borderRadius: 4,
      padding: 16,
      boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
      backgroundColor: 'white',
      '&:focus': {
          outline: 'none',
      },
    },
    infoWrapper: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'flex-start',
    },
    close: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer',
    },
    trophie: {
      width: 256,
      height: 175,
      display: 'flex',
      margin: isMobile ? '0 auto 34px' : '40px auto 50px',
      justifyContent: 'center',
      '& img': {
        margin: '30px 0 0 0'
      }
    },
    firstQuestion: {
      width: 256,
      height: 175,
      display: 'flex',
      margin: '0 auto',
      justifyContent: 'center',
      '& img': {
        margin: '30px 0 0 0'
      }
    },
    starsContainer: {
      display: 'flex',
      margin: 'auto',
    },
    star: {
      margin: '20px 8px 10px'
    },
    title: {
      fontSize: 28,
      color: '#35b9b6',
      margin: '0 auto 14px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    titleGreen: {
      fontSize: 28,
      color: '#6ecc47',
      margin: '0 auto 14px',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    subtitle: {
      fontSize: 20,
      color: '#10587f',
      textAlign: 'center',
      margin: '0 auto 56px',
      fontWeight: 'bold',
    },
    buttons: {
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    buttonContainer: {
      margin: 'auto',
    },
    ButtonBase: {
      margin: '0 0 48px',
      minWidth: '160px !important',
      width: 'initial',
    },
    divider: {
      width: '90%',
      margin: '0 auto 20px'
    },
    footer: {
      color: '#10587f',
      fontSize: 14,
      textAlign: 'center',
      margin: '0 auto 33px',
      width: '88%'
    },
})

function TrophieModal({ 
    open,
    trophieValidation,
    topic,
    handleClose,
    title,
    subtitle,
    footer,
    keyItem,
  }) {

    const classes = useStyles()
 
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={trophieValidation && trophieValidation === true ? open : false}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        key={keyItem}
      >
        <Fade in={trophieValidation && trophieValidation === true ? open : false}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>

              <div className={classes.close} onClick={handleClose}>
                <img src="/img/icons/close.svg" alt="close" />
              </div>

              {topic ?
                (topic === 'award-profile' ?
                  <div
                    className={classes.trophie}
                    style={{backgroundImage: 'url("/img/trophieModal/yellow-sparkles.svg")'}}
                  >
                    <img src="/img/trophieModal/big-trophie.svg" alt="trophie" />
                  </div> :
                topic === 'award-additional' ?
                  <div
                    className={classes.trophie}
                    style={{backgroundImage: 'url("/img/trophieModal/normal-blue-sparkles.svg")'}}
                  >
                    <img src="/img/trophieModal/additional-big-trophie.svg" alt="trophie" />
                  </div> :
                topic === 'frequent-answer' ?
                  <div
                    className={classes.trophie}
                    style={{backgroundImage: 'url("/img/trophieModal/light-blue-sparkles.svg")'}}
                  >
                    <img src="/img/trophieModal/answer-trophie.svg" alt="trophie" />
                  </div> :
                topic === 'high-time-response' ?
                  <div
                    className={classes.trophie}
                    style={{backgroundImage: 'url("/img/trophieModal/green-sparkles.svg")'}}
                  >
                    <img src="/img/trophieModal/fast-response-trophie.svg" alt="trophie" />
                  </div> :
                topic === 'first-question' ?
                  <div
                    className={isMobile ? classes.firstQuestion : classes.trophie}
                    style={{backgroundImage: 'url("/img/trophieModal/dark-blue-sparkles.svg")'}}
                  >
                    <img src="/img/trophieModal/first-question-trophie.svg" alt="trophie" />
                  </div> :
                  null
                ) :
                null
              }

              {isMobile && topic === 'first-question' ?
                <div className={classes.starsContainer}>
                  <img src='/img/trophieModal/star.svg' alt='stars' className={classes.star} />
                  <img src='/img/trophieModal/star.svg' alt='stars' className={classes.star} />
                  <img src='/img/trophieModal/star.svg' alt='stars' className={classes.star} />
                </div> :
                null
              }

              {title && topic === 'high-time-response' ?
                <p key={keyItem} className={classes.titleGreen}>
                  {title}
                </p> :
              title ?
                <p key={keyItem} className={classes.title}>
                  {title}
                </p> :
                null
              }

              {subtitle ?
                <p key={keyItem} className={classes.subtitle}>
                  {subtitle}
                </p> :
                null
              }
              
              <ButtonBase
                  type="submit"
                  onClick={handleClose}
                  variant="secondary"
                  className={classes.ButtonBase}
                  linkStyle={classes.buttonContainer}
              >
                  Entendido
              </ButtonBase>

              <Divider className={classes.divider} />
              
              {footer ?
                <footer key={keyItem} className={classes.footer}>
                  {footer}
                </footer> :
                null
              }
              
            </div>
          </div>
        </Fade>
      </Modal>
    )
}

export default TrophieModal;


// DOCUMENTACIÓN DE MI COMPONENTE

// <TrophieModal
//   open={open}
//   trophieValidation={trophie}
//   topic="award-additional"
//   handleClose={handleCloseTrophieModal}
//   title='Costo de servicios'
//   subtitle={['¡Felicidades', <br />, 'haz obtenido este logro!']}
//   footer='Hazle saber a tus posibles clientes el rango de precios que podrían pagar por una asesoría con el despacho.'
// />

// open: pon tu state (true o false)
// trophieValidation: pon tu validación de si debería o no dispararse dependiendo de si se ganó o no el trofeo (true o false)
// topic: selecciona de que tipo es el modal (award-profile, award-additional, frequent-answer, high-time-response o first-question)
// handleClose: pon tu función handleClose aquí
// title: Escribe un título, si no pones nada, simplemente no habrá ningún título
// subtitle: Escribe un subtítulo, si no pones nada, simplemente no habrá ningún subtítulo
// footer: Escribe un footer, si no pones nada, simplemente no habrá ningún footer

// HAY UN EJEMPLO COMENTADO EN src/pages/Profile/About/index.js